export const AngleRightSvg = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M9.74589 6.58744C9.9737 6.81525 9.9737 7.18459 9.74589 7.4124L5.66256 11.4957C5.43475 11.7235 5.06541 11.7235 4.8376 11.4957C4.6098 11.2679 4.6098 10.8986 4.8376 10.6708L8.50846 6.99992L4.8376 3.32906C4.6098 3.10126 4.6098 2.73191 4.8376 2.50411C5.06541 2.2763 5.43475 2.2763 5.66256 2.50411L9.74589 6.58744Z" fill="#4A5565" />
        </svg>

    )
}
